import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Tooltip
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  getUnSettledList,
  getReportAction,
} from "../../actions/settlementActions";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";

export default function UnSettledList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;

  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [transactionId, setTransactionId] = useState([]);
  const [messageId, setMessageId] = useState([]);

  // Fetch list
  const getList = async () => {
    const response = await dispatch(getUnSettledList(customerId));
    setRows(response || []);
  };

  useEffect(() => {
    getList();
  }, []);

  // Handle selection change
  // const handleSelectionChange = useCallback(
  //   (ids) => {
  //     setSelectedIds(ids);
  //     const selectedData = rows.filter((row) => ids.includes(row.id));
  //     setSelectedRows(selectedData);
  //     console.log("Selected rows data:", selectedData);
  //   },
  //   [rows]
  // );

  // Send report
  const getReport = async () => {
    if (selectedRows.length === 0) {
      setMsg("Please select at least one order.");
      setDialogOpen(true);
      return;
    }

    const payload = selectedRows.map((row) => ({
      transactionId: row?.context?.transaction_id,
      messageId: row?.context?.message_id,
    }));

    console.log("Payload to send:", selectedRows);

    await dispatch(getReportAction(payload, customerId));
    setMsg("Report request sent successfully.");
    setDialogOpen(true);
  };

  const redirect = (row) => {
    navigate(`/app/management/unsettled-list`, { state: { row } });
  };
  const columns = [
    { field: "_id", headerName: "_id", flex: 1 },
    {
      field: "context",
      headerName: "Transaction ID",
      flex: 1,
      valueGetter: ({ row }) => row?.context?.transaction_id,
    },
    { field: "settlementStatus", headerName: "Status", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    { field: "createdAt", headerName: "Created At", flex: 1 },
    { field: "updatedAt", headerName: "Updated At", flex: 1 },
    {
      field: "code",
      headerName: "City",
      flex: 1,
      valueGetter: ({ row }) => row?.context?.location?.city.code,
    },
    {
      field: "city",
      headerName: "Country",
      flex: 1,
      valueGetter: ({ row }) => row?.context?.location?.country?.code,
    },
    {
            field: "action",
            disableClickEventBubbling: true,
            headerName: "Action",
            renderCell: (params) => {
              const redirectToView = () => {
                redirect(params.row);
              };
      
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center", // vertical center alignment
                    justifyContent: "flex-start",
                    gap: 1,
                  }}
                >
                  <Tooltip title="View details">
                    <Box sx={{ cursor: "pointer" }} onClick={redirectToView}>
                      <RemoveRedEyeRoundedIcon />
                    </Box>
                  </Tooltip>
                  {/* <Tooltip title="View details">
                    <Box sx={{ cursor: "pointer" }} onClick={redirectToEdit}>
                      <EditIcon />
                    </Box> 
                  </Tooltip>*/}
                </Box>
              );
            },
            flex: 1,
          },
  ];

  return (
    <Box sx={{ p: 4, backgroundColor: "#fff", borderRadius: 2 }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          variant="h3"
          color="textPrimary"
          style={{ marginLeft: "0em" }}
        >
          Unsettled List
        </Typography>
      </Grid>
<Grid item xs={12}>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={rows}
          getRowId={(row) => row._id} // 👈 tells DataGrid to use backend _id
          columns={columns}
          checkboxSelection
          disableSelectionOnClick
          selectionModel={selectedIds}
          onSelectionModelChange={(newSelection) => {
            setSelectedIds(newSelection);
            const selectedData = rows.filter((row) =>
              newSelection.includes(row._id)
            );
            setSelectedRows(selectedData);
            console.log(
              "Selected rows data:",
              selectedData.map((item) => ({
                transactionId: item.context?.transaction_id,
                messageId: item.context?.message_id,
              }))
            );
          }}
        />
      </div>

      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={getReport}
          disabled={selectedRows.length === 0}
        >
          Request Report
        </Button>
      </Box>
</Grid>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Get Report</DialogTitle>
        <DialogContent>
          <Typography>{msg}</Typography>
        </DialogContent>
      </Dialog>
    </Grid>
    </Box>
  );
}
